import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const pathStopsApiRoutes = {
    list: apiDataManagerBaseURL + "pathstops/",
    listDraft: apiDataManagerBaseURL + "pathstopsdraft/",
    listByLinePaths: apiDataManagerBaseURL + "pathstops/bylinepaths/",
    listByPath: apiDataManagerBaseURL + "pathstops/bypath/",
    listByPathDraft: apiDataManagerBaseURL + "pathstopsdraft/bypath/",
    listByPathCodeDraft: apiDataManagerBaseURL + "pathstopsdraft/bypathcode/",
    load: apiDataManagerBaseURL + "pathstops/",
    create: apiDataManagerBaseURL + "pathstops/",
    createDraft: apiDataManagerBaseURL + "pathstopsdraft/",
    createSingleDraft: apiDataManagerBaseURL + "pathstopsdraft/single/",
    update: apiDataManagerBaseURL + "pathstops/",
    updateDraft: apiDataManagerBaseURL + "pathstopsdraft/",
    updateList: apiDataManagerBaseURL + "pathstops/",
    updateListDraft: apiDataManagerBaseURL + "pathstopsdraft/",
    delete: apiDataManagerBaseURL + "pathstops/",
    deleteDraft: apiDataManagerBaseURL + "pathstopsdraft/"
};

export class PathStopAPI {
    static list(networkEdition, provider = '') {
        const url = new URL(networkEdition, pathStopsApiRoutes.list);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraft(draftNetworkEdition, provider = '') {
        const url = `${pathStopsApiRoutes.listDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listByLinePaths(networkEdition, lineId, providerId = '') {
        const url = new URL(`${networkEdition}/${lineId}`, pathStopsApiRoutes.listByLinePaths);

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?provider=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static listByPath(networkEdition, pathId, providerId = '') {
        const url = new URL(`${networkEdition}/${pathId}`, pathStopsApiRoutes.listByPath);

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?provider=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static listByPathDraft(draftNetworkEdition, pathId, providerId = '') {
        const url = new URL(`${draftNetworkEdition}/${pathId}`, pathStopsApiRoutes.listByPathDraft);

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?provider=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static listByPathWithActiveDraft(networkEdition, draftNetworkEdition, pathId, providerId = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${pathId}`, pathStopsApiRoutes.listByPathDraft);

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?provider=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static listByPathCodeDraft(draftNetworkEdition, pathCode, providerId = '') {
        const url = `${pathStopsApiRoutes.listByPathCodeDraft}${draftNetworkEdition}/${pathCode}`;

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?provider=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static load(networkEdition, id) {
        const url = new URL(`${networkEdition}/${id}`, pathStopsApiRoutes.load);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(networkEdition, pathStops) {
        const url = new URL(networkEdition, pathStopsApiRoutes.create);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pathStops)
        });
    }

    static createDraft(draftNetworkEdition, pathStops) {
        const url = `${pathStopsApiRoutes.createDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pathStops)
        });
    }

    static createDraftSingle(draftNetworkEdition, pathStop) {
        const url = `${pathStopsApiRoutes.createSingleDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pathStop)
        });
    }

    static update(networkEdition, id, pathStop) {
        const url = new URL(`${networkEdition}/${id}`, pathStopsApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pathStop)
        });
    }

    static updateSpine(networkEdition, pathStopId, isInSpine) {
        const url = new URL(`${networkEdition}/${pathStopId}/${isInSpine}`, pathStopsApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static updateSpineDraft(networkEdition, pathStopId, isInSpine) {
        const url = new URL(`${networkEdition}/${pathStopId}/${isInSpine}`, pathStopsApiRoutes.updateDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static updateDraft(draftNetworkEdition, id, pathStop) {
        const url = `${pathStopsApiRoutes.updateDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pathStop)
        });
    }

    static updateList(networkEdition, pathStops) {
        const url = new URL(networkEdition, pathStopsApiRoutes.updateList);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pathStops)
        });
    }

    static updateListDraft(draftNetworkEdition, pathStops) {
        const url = `${pathStopsApiRoutes.updateListDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pathStops)
        });
    }

    static delete(networkEdition, id) {
        const url = new URL(`${networkEdition}/${id}`, pathStopsApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteDraft(draftNetworkEdition, id) {
        const url = `${pathStopsApiRoutes.deleteDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/datamanager/PathStopAPI.js